import { render } from "./CookieToast.vue?vue&type=template&id=3fcfcc6e&scoped=true"
import script from "./CookieToast.vue?vue&type=script&lang=js"
export * from "./CookieToast.vue?vue&type=script&lang=js"

import "./CookieToast.vue?vue&type=style&index=0&id=3fcfcc6e&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcfcc6e"]])

export default __exports__